import React, { useEffect, useState } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

export default function Grupos() {
  const [dados, setDados]       = useState<any[]>([])
  const [clientes, setClientes] = useState<any[]>([])
  const [tipo, setTipo]         = useState<"funcao"|"setor">("funcao")
  const [modal, setModal]       = useState(false)
  const [editando, setEditando] = useState<any>(null)
  const [form, setForm]         = useState({nome:"", tipo:"funcao", cliente_id:""})

  const carregar = async () => {
    try {
      const [g, c] = await Promise.all([
        axios.get(`${API}/grupos`),
        axios.get(`${API}/clientes`)
      ])
      setDados(g.data)
      setClientes(c.data)
    } catch {}
  }

  useEffect(()=>{ carregar() },[])

  const abrirNovo = (t: string) => {
    setEditando(null)
    setForm({nome:"", tipo:t, cliente_id:""})
    setModal(true)
  }

  const abrirEditar = (g:any) => {
    setEditando(g)
    setForm({nome:g.nome, tipo:g.tipo, cliente_id:g.cliente_id||""})
    setModal(true)
  }

  const salvar = async () => {
    if (!form.nome) return alert("Nome é obrigatório")
    try {
      if (editando) await axios.put(`${API}/grupos/${editando.id}`, form)
      else await axios.post(`${API}/grupos`, form)
      setModal(false)
      carregar()
    } catch(e:any) { alert(e.response?.data?.erro||"Erro ao salvar") }
  }

  const excluir = async (id:string) => {
    if (!window.confirm("Excluir?")) return
    try { await axios.delete(`${API}/grupos/${id}`); carregar() } catch {}
  }

  const funcoes = dados.filter(d=>d.tipo==="funcao")
  const setores = dados.filter(d=>d.tipo==="setor")

  const TabelaGrupo = ({lista, tipoLabel, tipoVal}: any) => (
    <div className="card" style={{flex:1}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
        <div style={{fontWeight:700,fontSize:14}}>{tipoLabel}</div>
        <button className="btn btn-primary" style={{fontSize:12,padding:"5px 12px"}}
          onClick={()=>abrirNovo(tipoVal)}>+ Adicionar</button>
      </div>
      {lista.length === 0 ? (
        <div style={{color:"#64748b",fontSize:12,textAlign:"center",padding:16}}>
          Nenhum {tipoLabel.toLowerCase()} cadastrado
        </div>
      ) : lista.map((g:any)=>(
        <div key={g.id} style={{display:"flex",alignItems:"center",gap:8,
          padding:"8px 0",borderBottom:"1px solid #2d4166"}}>
          <div style={{flex:1}}>
            <div style={{fontSize:13,fontWeight:500}}>{g.nome}</div>
            {g.cliente_nome && <div style={{fontSize:10,color:"#64748b"}}>{g.cliente_nome}</div>}
          </div>
          <button className="btn btn-ghost" style={{padding:"3px 8px",fontSize:12}}
            onClick={()=>abrirEditar(g)}>✏️</button>
          <button className="btn btn-ghost" style={{padding:"3px 8px",fontSize:12,color:"#f87171"}}
            onClick={()=>excluir(g.id)}>🗑️</button>
        </div>
      ))}
    </div>
  )

  return (
    <div style={{padding:24,height:"100%",overflowY:"auto"}}>
      <div style={{marginBottom:20}}>
        <h2 style={{fontSize:20,fontWeight:700}}>🗂️ Grupos</h2>
        <p style={{fontSize:13,color:"#64748b"}}>Cadastre funções e setores para os motoristas</p>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
        <TabelaGrupo lista={funcoes} tipoLabel="Funções" tipoVal="funcao" />
        <TabelaGrupo lista={setores} tipoLabel="Setores" tipoVal="setor" />
      </div>

      {modal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,
          display:"flex",alignItems:"center",justifyContent:"center"}}>
          <div className="card" style={{width:380}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:16}}>
              <h3>{editando?"✏️ Editar":"➕ Novo"} {form.tipo==="funcao"?"Função":"Setor"}</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModal(false)}>✕</button>
            </div>
            <div className="form-group" style={{marginBottom:12}}>
              <label>Nome *</label>
              <input value={form.nome} onChange={e=>setForm({...form,nome:e.target.value})}
                placeholder={form.tipo==="funcao"?"Ex: Motorista, Entregador...":"Ex: Logística, Vendas..."} />
            </div>
            <div className="form-group" style={{marginBottom:16}}>
              <label>Cliente (opcional)</label>
              <select value={form.cliente_id} onChange={e=>setForm({...form,cliente_id:e.target.value})}>
                <option value="">— Todos os clientes —</option>
                {clientes.map((c:any)=><option key={c.id} value={c.id}>{c.razao_social}</option>)}
              </select>
            </div>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
              <button className="btn btn-ghost" onClick={()=>setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar}>💾 Salvar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
